export default "__VITE_ASSET__Dvm39gn1__"